/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Dropdown,
  Segment,
  Header,
  Container,
  Checkbox,
  TextArea, Icon
} from "semantic-ui-react";
import { withFormik, Form as Formiker, Field as Fieldmik, FieldArray, getIn, } from "formik";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import MandatoryMark from "../common/mandatorymark";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import SearchDropdown from "./searchDropdown";
import ErrorMessage from "./ErrorMessages";
import { AllRegex } from "../../utils/validation";
import moment from "moment";
import { RouteCheckpoints } from "../routeComponent/routeCheckpoints";
import CreatAxios from "../axiosComponent/create";

const ModalCreateRoute = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
}) => {
  const [rawsequence, setsequence] = useState(0);
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [VendorsGroup, setVendorsGroup] = useState([]);
  var vendorIndex = 0;

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
    // if (values.vendor) handleSubmit();
  };

  const handleSubmited = () => {
    if (values.routeName && values.routeCode &&
      values.routeDescription && values.budgetedRouteTat && values.budgetedRouteKm) {
      if (values.checkPointLists[0].checkPointId == "") {
        alert('Please Add Checkpoint')
      } else {
        handleSubmit();
        setmodalOpen(false);
      }
    } else {
      handleSubmit();
    }
  };

  const setRouteList = (name, value) => {
    let stdObj = {
      checkPointType: "city",
      checkPointId: null,
      eta: "00:00:00",
      etd: "00:00:00",
      r_eta: "00:00:00",
      r_etd: "00:00:00",
      sequence: rawsequence + 1,
    };
    setsequence(stdObj.sequence);
    stdObj.checkPointId = value?.raw?.checkPointMasterId;
    stdObj.checkPointType = value?.raw?.checkPointType;
    setFieldValue(name, JSON.stringify(stdObj));
  };

  let addCheckpoint = (array) => {
    array.push({
      checkPointType: "",
      checkPointId: "",
      eta: "00:00:00",
      etd: "00:00:00",
      r_eta: "00:00:00",
      r_etd: "00:00:00",
      sequence: 1,
    })
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        // size="tiny"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            className="ui route_add_button"
          >
            <i aria-hidden="true" className="add icon"></i>
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {"Add Route"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
            <div className="ui form">
              <Formiker>
                <Container fluid className="mt-2 mb-2">
                  <Segment>
                    <div className="ui form tiny">
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("create.route_code.title") || "Route Code"}{" "}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          error={touched.routeCode && errors.routeCode ? true : false}
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="routeCode"
                            placeholder={
                              t("create.route_code.placeholder") || "Enter Route Code"
                            }
                          />
                          {touched.routeCode && errors.routeCode ? (
                            <div>
                              {t(`create.route_code.error_msg.${errors.routeCode}`) ||
                                errors.routeCode}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={2}></FormUi.Field>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("create.route_name.title") || "Route Name"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          error={touched.routeName && errors.routeName ? true : false}
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="routeName"
                            placeholder={
                              t("create.route_name.placeholder") || "Enter Route Name"
                            }
                          />
                          {touched.routeName && errors.routeName ? (
                            <div>
                              {t(`create.route_name.error_msg.${errors.routeName}`) ||
                                errors.routeName}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("create.budgeted_time.title") || "Route TAT (in HRS)"}{" "}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          error={
                            touched.budgetedRouteTat && errors.budgetedRouteTat
                              ? true
                              : false
                          }
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="budgetedRouteTat"
                            placeholder={
                              t("create.budgeted_time.placeholder") ||
                              "Enter Route TAT (In HRS) "
                            }
                          />
                          {touched.budgetedRouteTat && errors.budgetedRouteTat ? (
                            <div>
                              {t(
                                `create.budgeted_time.error_msg.${errors.budgetedRouteTat}`
                              ) || errors.budgetedRouteTat}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={2}></FormUi.Field>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("create.budgeted_distance.title") ||
                              "Budgeted Route KM (In KM)"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          error={
                            touched.budgetedRouteKm && errors.budgetedRouteKm
                              ? true
                              : false
                          }
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="budgetedRouteKm"
                            placeholder={
                              t("create.budgeted_distance.placeholder") ||
                              "Enter Route KM (In KMS)"
                            }
                          />
                          {touched.budgetedRouteKm && errors.budgetedRouteKm ? (
                            <div>
                              {t(
                                `create.budgeted_distance.error_msg.${errors.budgetedRouteKm}`
                              ) || errors.budgetedRouteKm}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("create.route_description.title") || "Route Description"}{" "}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={3}
                          error={
                            touched.routeDescription && errors.routeDescription
                              ? true
                              : false
                          }
                        >
                          <Fieldmik
                            component={"textarea"}
                            rows="3"
                            type="text"
                            style={{ width: "100%" }}
                            name="routeDescription"
                            placeholder={
                              t("create.route_description.placeholder") ||
                              "Enter Description"
                            }
                          />
                          {touched.routeDescription && errors.routeDescription ? (
                            <div>
                              {t(
                                `create.route_description.error_msg.${errors.routeDescription}`
                              ) || errors.routeDescription}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      {/* {_.isEmpty(editData) && ( */}
                      {/* <> */}
                      <Segment piled>
                        <center>
                          <Header size="small">
                            {t("create.route_list.title") || "Route List"}
                          </Header>
                        </center>
                        <Container className="small">
                          <FieldArray
                            name="checkPointLists"
                            render={(arrayHelpers) => (
                              <>
                                {values.checkPointLists &&
                                  values.checkPointLists.length > 0
                                  ? values.checkPointLists.map((items, index) => (
                                    <div key={index}>
                                      <label
                                        // style={{ fontSize: "0.85em" }}
                                        className="labelName"
                                      >
                                        {t(
                                          "create.route_list.checkpoint.title"
                                        ) || "Check point"}
                                      </label>
                                      <FormUi.Group inline>
                                        <FormUi.Field
                                          style={{ display: "flex" }}
                                          error={
                                            getIn(
                                              errors,
                                              `checkPointLists[${index}].checkPointId`
                                            ) &&
                                              getIn(
                                                touched,
                                                `checkPointLists[${index}].checkPointId`
                                              )
                                              ? true
                                              : false
                                          }
                                        >
                                          <SearchDropdown
                                            setField={setRouteList}
                                            masterRoute="getRouteCheckPoints"
                                            masterRouteKey="checkPointMasterId"
                                            masterRouteName="checkPointName"
                                            fieldName={`checkPointLists[${index}].checkPointId`}
                                          />
                                          <ErrorMessage
                                            name={`checkPointLists[${index}].checkPointId`}
                                          />
                                          <Button
                                            className="ui mini"
                                            hidden={index === 0}
                                            style={{ marginLeft: "10px" }}
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                            basic
                                            icon
                                            color="red"
                                          >
                                            <Icon name="trash" />{" "}
                                          </Button>
                                        </FormUi.Field>
                                      </FormUi.Group>
                                    </div>
                                  ))
                                  : ""}
                                <Button
                                  onClick={() => addCheckpoint(arrayHelpers)
                                    // arrayHelpers.push({
                                    //   checkPointType: "",
                                    //   checkPointId: "",
                                    //   eta: "00:00:00",
                                    //   etd: "00:00:00",
                                    //   r_eta: "00:00:00",
                                    //   r_etd: "00:00:00",
                                    //   sequence: rawsequence + 1,
                                    // })
                                  }
                                  basic
                                  color="blue"
                                  size="mini"
                                  icon
                                  type="button"
                                >
                                  <Icon name="plus" />
                                  {t(
                                    "create.route_list.checkpoint.action.add_more"
                                  ) || "Add More"}
                                </Button>
                              </>
                            )}
                          />
                        </Container>
                      </Segment>
                      {/* </> */}
                      {/* //   )} */}
                    </div>
                  </Segment>
                  {/* {editData.routeMasterId && (
            <RouteCheckpoints route_id={editData.routeMasterId} />
          )} */}
                </Container>

              </Formiker>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {isSubmitting ? "Loading..." : ""}
          {/* <Container className="p-3" textAlign="center"> */}
          <Button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit" onClick={handleSubmited}
          >
            {t("create.action_button.submit") || "Submit"}
          </Button>
          {/* </Container> */}
        </Modal.Actions>
      </Modal>
    </div>
  );
};
// TODO: validation
const FormikBroadcast = withFormik({
  validationSchema: yup.object({
    routeName: yup.string().required("required"),
    routeCode: yup.string().optional(),
    routeDescription: yup.string().required("required"),
    budgetedRouteTat: yup.string().required("required"),
    budgetedRouteKm: yup.string().required("required"),
    checkPointLists: yup.array().of(
      yup.object().shape({
        checkPointId: yup.string().optional("required"),
      })
    ),
  }),
  mapPropsToValues: (props) => {
    return {
      routeName: "",
      routeCode: "",
      budgetedRouteTat: "",
      budgetedRouteKm: "",
      routeDescription: "",
      checkPointLists: [
        {
          checkPointType: "",
          checkPointId: "",
          eta: "00:00:00",
          etd: "00:00:00",
          r_eta: "00:00:00",
          r_etd: "00:00:00",
          sequence: +1,
        },
      ],
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    let routeDetails = [];
    values.checkPointLists.forEach((item, index) => {
      routeDetails.push(JSON.parse(item.checkPointId));
    });
    let submitData = {
      routeName: values.routeName,
      routeCode: values.routeCode,
      budgetedRouteKm: values.budgetedRouteKm,
      budgetedRouteTat: values.budgetedRouteTat,
      routeDescription: values.routeDescription,
      routeList: JSON.stringify(routeDetails),
    };
    CreatAxios({
      url: "routeMaster",
      payload: { ...submitData },
    })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: "Route Created",
        };
        props.successAlertDispatcher(alert);
        window.location.reload()
      })
      .catch((err) => {
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: "Error while creating route",
        };
        props.errorAlertDispatcher(alert);
      });
  },
})(ModalCreateRoute);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("route")(FormikBroadcast)
);
